module.exports = __webpack_public_path__ + "img/wa_24px.b8043019.svg";